import React from "react";
import { useTranslation } from "react-i18next";

const ComponentTitleAndSousTitle = (props) => {
  const { t } = useTranslation();

  const { title, sousTitle } = props;

  return (
    <div className="TitleAndSousTitle">
      <div className="title">{title}</div>
      <div className="sousTitle">{sousTitle}</div>
    </div>
  );
};

export default ComponentTitleAndSousTitle;
